import React, { useState, useEffect } from 'react'
import ConditionsTable from '../../../Sponsor/Agreement/components/Conditions'
import { sponsorRegistration } from '../../../../../core/data/json/contractFarming';
import SponsorAgreementP1 from '../../../Sponsor/Agreement/components/Page1';
import { useLocation } from 'react-router-dom';
import { useSelector } from "react-redux";
import 'react-toastify/dist/ReactToastify.css';
import { toast } from "react-toastify";


interface AggrementS {
    reviewedData?: any;
    appdata?: any;
    conditionsData?: any;
    setConditionsData?: any;
    roleIdentifier?: any
}

const MBAformN = ({ reviewedData, appdata, conditionsData, setConditionsData, roleIdentifier }: AggrementS) => {

    // const token = useSelector((state: any) => state.auth.token);
    const [isEnable, setIsEnable] = useState<any>(true);
    const [productDetails, setProductDetails] = useState<any>({});

    interface ConditionItem {
        itemNo: string;
        item: string;
        isBlankExist: boolean;
        blank: any[];
        subItem: {
            subitemNo: string;
            subItemSno: string;
            subItemVal: string;
        }[];
        isTableExist: boolean;
        tableItems: any[];
        isUpdated?: boolean;
        status?: 'normal' | 'deleted' | 'updated' | 'added'; // To change conditons 
    }

    // const [conditionsData, setConditionsData] = useState<ConditionItem[]>(sponsorRegistration);

    const handleNext = () => {
      
    }

    return (
        <div>

            {roleIdentifier !== "SPO" &&
                <div className='m-5 bg-white p-5'>
                    <div className="text-center ">
                        <h2>FORM - N</h2>
                        <h2>[SEE RULE 119(5)]</h2>
                        <h2>REGISTER FOR REGISTRATION OF CONTRACT FARMING AGREEMENT</h2>
                    </div>
                    <div id='table' className='w-100 mb-4 overflow-hidden border bg-white border-secondary rounded'>
                        <div id='head' className='d-flex w-100 text-center rounded-top border-bottom border-secondary' style={{ backgroundColor: "#CCE3FF" }}>
                            <h4 className='col-1 p-2 justify-content-center d-flex border-secondary border-end'>Sr No.</h4>
                            <div className='col-4 d-flex flex-column border-secondary border-end'>
                                <div className='p-2 h-100 w-100 border-bottom border-secondary'>
                                    <h4 className='text-center'>Name of parties to the agreement </h4>
                                </div>
                                <div className='d-flex '>
                                    <h4 className='col-4 p-2 justify-content-center d-flex border-secondary border-end'>First party (Farmer)</h4>
                                    <h4 className='col-4 p-2 justify-content-center d-flex border-secondary border-end'>Second Party (Purchaser)</h4>
                                    <h4 className='col-4 p-2 justify-content-center d-flex'>Third party</h4>
                                </div>
                            </div>
                            <h4 className='col-1 p-2 justify-content-center d-flex border-secondary border-end'>Type of agricultural produce</h4>
                            <h4 className='col-2 p-2 justify-content-center d-flex border-secondary border-end'>Estimated quantity of agricultural produce</h4>
                            <h4 className='col-1 p-2 justify-content-center d-flex border-secondary border-end'>Period of contract</h4>
                            <h4 className='col-2 p-2 justify-content-center d-flex border-secondary border-end'>Estimated value of agricultural produce</h4>
                            <h4 className='col-1 p-2 justify-content-center d-flex border-secondary border-end'>Date of agreement</h4>
                        </div>

                        <div id='body' className='d-flex text-black w-100 text-center rounded-top border-bottom border-secondary'>
                            <div className='col-1 p-2 justify-content-center d-flex border-secondary border-end'>
                                <p>1</p>
                            </div>
                            <div className='col-4 d-flex flex-column border-secondary border-end'>
                                <div className='d-flex '>
                                    <div className='col-4 p-2 justify-content-center d-flex border-secondary border-end'>
                                        <p>{reviewedData?.FirstPartyPresenceName || 'N/A'}</p></div>
                                    <div className='col-4 p-2 justify-content-center d-flex border-secondary border-end'>
                                        <p>{reviewedData?.SecondPartyPresenceName || 'N/A'}</p></div>
                                    <div className='col-4 p-2 justify-content-center d-flex'>
                                        <p>N/A</p></div>
                                </div>
                            </div>
                            <div className='col-1 p-2 justify-content-center d-flex border-secondary border-end'>
                                <p>{productDetails?.grade || 'N/A'}</p>
                            </div>
                            <div className='col-2 p-2 justify-content-center d-flex border-secondary border-end'>
                                <p>{productDetails?.quantity || 'N/A'}</p>
                            </div>
                            <div className='col-1 p-2 justify-content-center d-flex border-secondary border-end'>
                                <p>{productDetails?.periodOfDelivery || 'N/A'}</p>
                            </div>
                            <div className='col-2 p-2 justify-content-center d-flex border-secondary border-end'>
                                <p>{productDetails?.price || 'N/A'}</p>
                            </div>
                            <div className='col-1 p-2 justify-content-center d-flex border-secondary border-end'>
                                <p>{productDetails?.dateOFAgreement || 'N/A'}</p>
                            </div>

                        </div>
                    </div>
                    {/* CONDITIONS TABLE is already rendered inside the preview Form M below (SponsorAgreementP1) */}

                </div>
            }
            <div className='d-flex align-content-center justify-content-between  mt-2'>
                {roleIdentifier !== "SPO" &&
                    <p className='m-0 ms-5' style={{ fontSize: "1.25rem" }}>Preview of Agreement Form submitted by Sponsor</p>
                }
                <p></p>
                {(appdata?.Status !== "pending" || appdata?.appStatusLevel == "pendingAtMBA") ?
                    (
                        reviewedData?.buttonName &&
                        <button className='me-5 btn btn-outline-secondary' onClick={() => {
                            setIsEnable(!isEnable);
                            if (!isEnable) {
                                toast.info("Edit mode disabled", { position: "top-right" });

                            } else {
                                toast.success("Edit mode enabled", { position: "top-right" });
                            }
                        }} >{isEnable ? 'Edit Enable' : 'Edit Disable'}
                        </button>
                    ) :
                    ('')
                }
            </div>

            <SponsorAgreementP1
                conditionsData={conditionsData}
                setConditionsData={setConditionsData}
                onNext={handleNext}
                reviewedData1={reviewedData || {}}
                isEnable1={isEnable}
                appdata1={appdata || {}}
                setProductDetails={setProductDetails}
            />
        </div>
    )
}

export default MBAformN